import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./confOverlaystyles.scss"; 
import CheckBox from "../../../../Common/CommonComponents/SceCheckBox";
import classes from "./ConfirmationPopup.scss";
import SceTextBox from "../../../../Common/TextBox/sceText";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
import PBSceSelectBox from  "../../../../BillingAndPayment/Payment/PaperlessBilling/Common/paperlessBillingSelectBox";
import FocusTrap from 'focus-trap-react';


class ConfirmationPopup extends React.Component {
    
    constructor(props) {
        super(props);
      
        this.strings = getLocalizedStrings("PbConfPopup");
        let closeIcon;
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
  
}

componentDidMount() {
       
    document.addEventListener('mousedown', this.handleClickOutside);
}
componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
}

setWrapperRef(node) {
    this.wrapperRef = node;
}

handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
       
   this.props.isConfOpen();
   

    }
 } 
doneButtonHandler(){
    this.props.isConfOpen();
    this.props.isOpen();
    window.location.reload();
}

    render() {
        
    
        let serviceAccountDetailsJSX;
        serviceAccountDetailsJSX = <ServiceAccountDetailsComponent accountData={this.props.accountData} />;
        //alert("r"+this.state.doneButtonPress);
        return (
            <FocusTrap 
             focusTrapOptions={{
                allowOutsideClick: true,
            }}
            >
            <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div  ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                        
                            <div className='row'>

                                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.TurnOnPopupTitle}<button className={classes.iconClose} onClick={this.doneButtonHandler.bind(this)}><img  src={this.closeIcon} alt="Close Icon"  /></button></div>
                            </div>
                                <div>{(this.props.enrolledCount > 1) ?
                                <div>
                                <div>
                                
                                <p className={classes.bulkHeading}>{this.strings.BulkEnrollMsg} {this.props.enrolledCount}{this.strings.ActMsg}</p>
                                <p className={classes.genericBillMsg}>{this.strings.GenericBillMsg}</p>
                                <div className={classes.Mutliemail}>{this.strings.Email}<span className={classes.confDate}>{this.props.primaryEmail}</span>
                                </div>
                                </div> 
                              
                                </div>
                                
                            
                                :
                                <div>
                                
                                
                                <div className='row'> 
                                <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{this.strings.Account}</div>
                                <div className={'col-xs-12 '}>{serviceAccountDetailsJSX}</div>
                                
                                <p className={'col-xs-12 '+classes.msgData}>{this.strings.Message}</p>
                                <div className={classes.confMsg}>
                                <div>{(this.props.nextStDate) ? 
                                  <div className={classes.date}>{this.strings.BillAvailable}<span className={classes.confDate}>
                                  {app.appUtil.formatDate(this.props.nextStDate ? app.appUtil.stringToDate(this.props.nextStDate, 'YYYY-MM-DD') : '', 'dddd, MMMM D, YYYY')}
                                  
                                  </span>
                                  </div>
                                
                                
                                   :<div> <p className={'col-xs-12 '+classes.genericMsg}>{this.strings.GenericBillMsg}</p>
                            
                                   </div>
                                 
                                }
                                </div>
                                
                            </div>
                            <div className={classes.email}>{this.strings.Email}<span className={classes.confDate}>{this.props.primaryEmail}</span>
                            </div>
                            
                                </div>
                                </div>
                                
                                }
                                </div>
                       
                            
                            

                           
                            <div className={"text-align-center"}>
                             <div className={classes.footerButton}>
                                            <SceButton
                                                
                                                buttonType="primary"
                                                value={this.strings.Done}
                                                onClick={this.doneButtonHandler.bind(this)}
                                            />
                                </div> 
                                        </div>
                                        </div>

                           
            </div>
            </div>
            </div>
            </FocusTrap>
            
        );
    }
}
export default ConfirmationPopup;
